import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};
export const skeleton: SxStyle = {
  width: '100%',
  height: (p) => p.spacing(7),
  borderRadius: (p) => p.spacing(0.5),
};
